module.exports = __webpack_public_path__ + "static/media/features-split-image-02.9c0e5e99.png";